<ul id="{{ 'ul' + fieldKey }}" class="bulkList" style="margin-bottom: 0px !important;">
    @for(item of listOptions; track item; let i = $index){<li id="{{ 'li' + item.key }}">
        <span (click)="onClick(item)">
            <i aria-hidden="true" class="" [ngClass]="item.iconClass"></i>
            {{ item.value | translate }}
        </span>
    </li>}
</ul>